<div class='page-body'>
  <div
    class='security-form-container'
    fxLayout='column'
    fxFlex
    *ngIf='showLoginForm() || authService.serverTokenReleaseFailedOnLogout; else flexPage'
  >
    <form
      [formGroup]='loginForm'
      (ngSubmit)='logUserIn()'
      autocomplete='off'
      class='flex-max security-form login'
      fxLayout='column'
      fxLayoutAlign='center center'
    >
      <h3 class='mis' data-cy='system-name' vrm-color>{{ cService.readyTranslations.login.systemName }}</h3>

      <div
        class='security-card mat-elevation-z2'
        fxLayout='column'
        [style.width]="cService.isPcViewport ? '30%' : ''"
      >
        <div *ngIf='!issueLogin' class='card-header' [style.background]="''">
					<span *ngIf='cService.passwordResetInProgress; else signInTitle'>
						{{ cService.readyTranslations.login.resetPassword }}
					</span>

          <ng-template #signInTitle>
            <span>{{ cService.readyTranslations.login.signInButton }}</span>
          </ng-template>
        </div>

        <div *ngIf='issueLogin' class='card-header' [style.background]="''">
          <span>{{ cService.readyTranslations.login.loginHelpTitle }}</span>
        </div>

        <!-- Body -->
        <div>
          <div fxLayout='column' *ngIf='issueLogin' class='padding-25'>
            <p>
              {{ cService.readyTranslations.login.loginHelpExistingClient }}
              <a target='_blank' s href='https://www.edriving.com/support/'>
                {{ cService.readyTranslations.login.loginHelpLink }}
              </a>
            </p>
            <br />

            <p>
              <strong>{{ cService.readyTranslations.login.loginHelpAmazonDsp }}</strong>
              {{ cService.readyTranslations.login.loginHelpAmazon }}
              <a target='_blank' href='https://www.edriving.com/amazon-dsp-support/'>
                {{ cService.readyTranslations.login.loginHelpAmazonLink }}
              </a>
            </p>
            <div class='backtosign' (click)='issueLogin = false'>
							<span>
								<mat-icon style='top: 7px; position: relative'>arrow_back</mat-icon>
                {{ cService.readyTranslations.login.backToSignIn }}
							</span>
            </div>
          </div>
          <div fxLayout='column' *ngIf='!issueLogin' class='padding-25 login-form-body'>
            <div class='login-notification' *ngIf='!cService.passwordResetInProgress'>
              {{ cService.readyTranslations.login.notification }}
            </div>
            <mat-form-field>
              <input
                id='username'
                matInput
                placeholder='{{ cService.readyTranslations.login.username }}'
                formControlName='username'
              />
              <mat-error *ngIf="!loginForm.get('username').valid && loginForm.get('username').touched">
                {{ '' | getFormErrorMessage: 'Username':loginForm.get('username'):'required' }}
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf='companyRequired'>
              <input
                id='company'
                matInput
                placeholder='{{ cService.readyTranslations.login.companyLabel }}'
                formControlName='company'
              />
              <mat-error *ngIf="!loginForm.get('company').valid && loginForm.get('company').touched">
                {{ '' | getFormErrorMessage: 'Company':loginForm.get('company'):'required' }}
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf='!cService.passwordResetInProgress'>
              <input
                id='password'
                matInput
                placeholder='{{ cService.readyTranslations.login.passwordLabel }}'
                formControlName='password'
                [type]="hide ? 'password' : 'text'"
              />

              <mat-icon matSuffix (click)='hide = !hide'>visibility</mat-icon>
              <mat-error *ngIf="!loginForm.get('password').valid">
                {{ '' | getFormErrorMessage: 'Password':loginForm.get('password'):'required' }}
              </mat-error>
            </mat-form-field>

            <div fxLayout='row' fxLayoutAlign='space-between'>
              <button
                type='reset'
                mat-button
                (click)='clearLoginForm()'
                class='sharp-corners'
                data-cy='clear-login-form-button'
              >
                {{ cService.readyTranslations.login.clearButton }}
              </button>

              <button type='button' mat-button class='sharp-corners' (click)='commencePasswordReset()'>
								<span *ngIf='cService.passwordResetInProgress; else signInInstead'>
									<mat-icon style='top: 7px; position: relative'>arrow_back</mat-icon>
                  {{ cService.readyTranslations.login.backToSignIn }}
								</span>

                <ng-template #signInInstead>
                  <span>{{ cService.readyTranslations.login.resetPassword }}</span>
                </ng-template>
              </button>
            </div>
          </div>

          <div class='margin-10 above-login-help'>
            <div *ngIf='authService.loginErrorMessage' class='security-error-message'>
              {{ authService.loginErrorMessage }}

              <countdown
                *ngIf='authService.messageHasCountdown'
                data-cy='login-delay-countdown'
                [counter]='80'
                [interval]='1000'
                (value)='getLiveCountdown($event)'
              >
                <strong>{{ liveCountdownValue }} {{ 'UNITS.seconds' | translate }}</strong>
              </countdown>
            </div>
            <div *ngIf='authService.loginSuccessMessage' class='security-success-message'>
              {{ authService.loginSuccessMessage }}
            </div>
          </div>
        </div>
        <div
          *ngIf='!issueLogin && !cService.passwordResetInProgress'
          fxLayout='row'
          fxLayoutAlign='space-between'
          class='login-help'
        >
          <a (click)='issueLogin = true' href='javascript:void(0)'>{{
            cService.readyTranslations.login.loginHelp
            }}</a>
        </div>
        <!-- Footer / buttons -->
        <div *ngIf='!issueLogin' class='padding-10'>
          <button
            type='submit'
            data-cy='login-button'
            fxFlex='auto'
            mat-raised-button
            vrm-raised-button
            *ngIf='!cService.passwordResetInProgress'
            [disabled]='!loginForm.valid || loginInProgress || authService.messageHasCountdown'
            class='margin-r-40 bold sharp-corners'
            color='primary'
          >
            {{ cService.readyTranslations.login.signInButton }}
          </button>

          <button
            data-cy='password-reset-button'
            type='submit'
            fxFlex='auto'
            mat-raised-button
            vrm-raised-button
            [disabled]="loginForm.get('username').invalid || loginForm.get('company').invalid"
            *ngIf='cService.passwordResetInProgress'
            class='margin-r-40 bold sharp-corners'
            color='primary'
          >
            {{ cService.readyTranslations.login.requestPasswordReset }}
          </button>
        </div>
      </div>
    </form>
    <app-footer></app-footer>
  </div>

  <ng-template #flexPage><span fxFlex></span></ng-template>
</div>
